export class Tool {
    constructor(public name: String,
        public route:String
    ) {
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/main.tool.ts
 **/